// frontend/src/pages/landing/Home.tsx
// LP-01: 3-section landing page — Hero + Proof + CTA
// LP-02: Dual-mode Founder/Program toggle with shared state

import React, { useState, useEffect } from 'react';
import Hero from '../../components/marketing/Hero';
import ProofSection from '../../components/marketing/ProofSection';
import { safeGetItem, safeSetItem } from '../../utils/safeStorage';

const Home: React.FC = () => {
  // ✅ AUDIENCE TOGGLE: Shared across Hero + ProofSection
  const [audienceMode, setAudienceMode] = useState<'founder' | 'program'>('founder');

  // Load saved preference on mount
  useEffect(() => {
    const saved = safeGetItem('xprojex_audience_mode');
    if (saved === 'founder' || saved === 'program') {
      setAudienceMode(saved);
    }
  }, []);

  // Save preference when changed
  const handleModeChange = (mode: 'founder' | 'program') => {
    setAudienceMode(mode);
    safeSetItem('xprojex_audience_mode', mode);
  };

  return (
    <div>
      <Hero audienceMode={audienceMode} onModeChange={handleModeChange} />
      <ProofSection audienceMode={audienceMode} />
    </div>
  );
};

export default Home;
